import React from 'react';

const Meaning = (props)=>{
    const { divStyle, mStyle } = styles;
    return(
        <div style={divStyle}>
            <p><span>Means ~ </span><span style={mStyle}>{props.currentName.meaning}</span></p>
        </div>
    )
};
const styles = {
    divStyle:{
        fontSize: "12px",
        marginTop: "7px",
        fontWeight: "bold",
    },
    mStyle:{
     fontWeight: "bold",
     background: "#83d0f2",
     borderRadius: "2px",
     padding: "5px",
     color: "white"
    },
    spanStyle:{
        fontFamily: "sans-serif",
        fontWeight: "bold",
        fontSize: "12px",
        color: "#222222",
        padding: "2px",
        marginLeft: "2px",
        marginRight: "2px"
    },


}
export default Meaning;


// WEBPACK FOOTER //
// ./src/components/mainpage/box/meaning.js